// @ts-strict-ignore
import type { PricesPageProps } from "types/prices";
import isEmpty from "lodash/isEmpty";
import find from "lodash/find";
import get from "lodash/get";
import cloneDeep from "lodash/cloneDeep";
import { COMPONENT_TYPES } from "constants/common";
import type { UTCTimestamp } from "lightweight-charts";
import { testData } from "constants/prices";
import type { Document } from "@contentful/rich-text-types";

const imageData = {
  url: "",
  altText: "",
  width: null,
  height: null
};

const ctaData = {
  link: "",
  name: "",
  image: cloneDeep(imageData),
  type: ""
};

const contentData = {
  question: "",
  answer: "",
  image: cloneDeep(imageData)
};

const argsStructure = {
  breadcrumbs: {
    cta: []
  },
  aboutAccordion: {
    title: "",
    content: []
  },
  aboutCoin: {
    title: "",
    description: null
  },
  investmentSmallCard: {
    title: "",
    subTitle: "",
    image: cloneDeep(imageData),
    cta: [],
    coinFullName: ""
  },
  cryptopediaSmallCard: {
    title: "",
    subTitle: "",
    image: cloneDeep(imageData),
    cta: [],
    coinFullName: "",
    isDisplay: false
  },
  coinResources: {
    title: "",
    cta: []
  },
  faqAccordion: {
    title: "",
    content: []
  },
  priceBlogs: {
    title: "",
    coinFullName: "",
    coinSlug: ""
  },
  priceArticles: {
    title: "",
    coinFullName: "",
    coinSlug: ""
  },
  tradeForm: {
    title: "",
    cta: [],
    coinFullName: "",
    coinName: "",
    isCustody: false,
    isTrading: false
  }
};
export const handlePricePageData = (props: PricesPageProps) => {
  const args = cloneDeep(argsStructure);
  const extendedData: any = props || {};
  const pricePageListData: any =
    extendedData?.currentCoinDetail?.componentContent || [];
  const breadcrumbs =
    find(
      pricePageListData,
      (el) =>
        el?.fields?.componentType?.fields?.componentType ===
        COMPONENT_TYPES.BREADCRUMB
    ) || {};
  const breadcrumbsCta = breadcrumbs?.fields?.cta || [];
  if (!isEmpty(breadcrumbsCta)) {
    breadcrumbsCta.forEach((data: any) => {
      const ctaCloneData = cloneDeep(ctaData);
      ctaCloneData.name = get(data?.fields, "title", "");
      ctaCloneData.link = get(data?.fields, "link", "");
      args.breadcrumbs.cta.push(ctaCloneData);
    });
  }

  const aboutAccordion =
    find(
      pricePageListData,
      (el) =>
        el?.fields?.componentType?.fields?.componentType ===
        COMPONENT_TYPES.ABOUT_ACCORDION
    ) || {};
  const aboutAccordionCta = aboutAccordion?.fields?.faq || [];
  args.aboutAccordion.title = get(aboutAccordion?.fields, "title", "");
  if (!isEmpty(aboutAccordionCta)) {
    aboutAccordionCta.forEach((data: any) => {
      const contentCloneData = cloneDeep(contentData);
      contentCloneData.question = get(data?.fields, "questionTitle", "");
      contentCloneData.answer = get(data?.fields, "answerRichText", null);
      contentCloneData.image.url = get(
        data?.fields?.expandImage?.fields?.file,
        "url",
        ""
      );
      contentCloneData.image.altText = get(
        data?.fields?.expandImage?.fields,
        "title",
        ""
      );
      contentCloneData.image.width = get(
        data?.fields?.expandImage?.fields?.file?.details?.image,
        "width",
        null
      );
      contentCloneData.image.height = get(
        data?.fields?.expandImage?.fields?.file?.details?.image,
        "height",
        null
      );
      args.aboutAccordion.content.push(contentCloneData);
    });
  }

  const aboutCoin =
    find(
      pricePageListData,
      (el) =>
        el?.fields?.componentType?.fields?.componentType ===
        COMPONENT_TYPES.ABOUT_COIN
    ) || {};

  args.aboutCoin.title = get(aboutCoin?.fields, "title", "");
  args.aboutCoin.description = get(
    aboutCoin?.fields,
    "descriptionRichText",
    null
  ) as Document;

  const investmentSmallCard =
    find(
      pricePageListData,
      (el) =>
        el?.fields?.componentType?.fields?.componentType ===
        COMPONENT_TYPES.INVESTMENT_SMALL_CARD
    ) || {};

  args.investmentSmallCard.title = get(
    investmentSmallCard?.fields,
    "title",
    ""
  );
  args.investmentSmallCard.subTitle = get(
    investmentSmallCard?.fields,
    "subtitle",
    ""
  );
  args.investmentSmallCard.coinFullName = get(
    props?.initialOverview,
    "name",
    ""
  );
  const investmentSmallCardCta = investmentSmallCard?.fields?.cta || [];
  if (!isEmpty(investmentSmallCardCta)) {
    investmentSmallCardCta.forEach((data: any) => {
      const ctaCloneData = cloneDeep(ctaData);
      ctaCloneData.name = get(data?.fields, "title", "");
      ctaCloneData.link = get(data?.fields, "link", "");
      args.investmentSmallCard.cta.push(ctaCloneData);
    });
  }

  const investmentSmallCardImages =
    investmentSmallCard?.fields?.imageDesktop || [];
  if (!isEmpty(investmentSmallCardImages)) {
    if (investmentSmallCardImages?.length > 0) {
      args.investmentSmallCard.image.url = get(
        investmentSmallCardImages[0]?.fields?.file,
        "url",
        ""
      );
      args.investmentSmallCard.image.width = get(
        investmentSmallCardImages[0]?.fields?.file?.details?.image,
        "width",
        null
      );
      args.investmentSmallCard.image.height = get(
        investmentSmallCardImages[0]?.fields?.file?.details?.image,
        "height",
        null
      );
      args.investmentSmallCard.image.altText = get(
        investmentSmallCardImages[0]?.fields,
        "title",
        ""
      );
    }
  }

  const coinResources =
    find(
      pricePageListData,
      (el) =>
        el?.fields?.componentType?.fields?.componentType ===
        COMPONENT_TYPES.COIN_RESOURCES
    ) || {};
  args.coinResources.title = get(coinResources?.fields, "title", "");
  const coinResourcesCta = coinResources?.fields?.cta || [];
  if (!isEmpty(coinResourcesCta)) {
    coinResourcesCta.forEach((data: any) => {
      const ctaCloneData = cloneDeep(ctaData);
      ctaCloneData.name = get(data?.fields, "title", "");
      ctaCloneData.link = get(data?.fields, "link", "");
      ctaCloneData.type = get(data?.fields, "link", "");
      ctaCloneData.image.url = get(
        data?.fields?.image?.fields?.file,
        "url",
        ""
      );
      ctaCloneData.image.altText = get(
        data?.fields?.image?.fields,
        "title",
        ""
      );
      ctaCloneData.image.width = get(
        data?.fields?.image?.fields?.file?.details?.image,
        "width",
        null
      );
      ctaCloneData.image.height = get(
        data?.fields?.image?.fields?.file?.details?.image,
        "height",
        null
      );

      args.coinResources.cta.push(ctaCloneData);
    });
  }

  const faqAccordion =
    find(
      pricePageListData,
      (el) =>
        el?.fields?.componentType?.fields?.componentType ===
        COMPONENT_TYPES.FAQ_ACCORDION
    ) || {};
  const faqAccordionCta = faqAccordion?.fields?.faq || [];
  args.faqAccordion.title = get(faqAccordion?.fields, "title", "");
  if (!isEmpty(faqAccordionCta)) {
    faqAccordionCta.forEach((data: any) => {
      const contentCloneData = cloneDeep(contentData);
      contentCloneData.question = get(data?.fields, "questionTitle", "");
      contentCloneData.answer = get(data?.fields, "answerRichText", null);
      contentCloneData.image.url = get(
        data?.fields?.expandImage?.fields?.file,
        "url",
        ""
      );
      contentCloneData.image.altText = get(
        data?.fields?.expandImage?.fields,
        "title",
        ""
      );
      contentCloneData.image.width = get(
        data?.fields?.expandImage?.fields?.file?.details?.image,
        "width",
        null
      );
      contentCloneData.image.height = get(
        data?.fields?.expandImage?.fields?.file?.details?.image,
        "height",
        null
      );
      args.faqAccordion.content.push(contentCloneData);
    });
  }

  const cryptopediaSmallCard =
    find(
      pricePageListData,
      (el) =>
        el?.fields?.componentType?.fields?.componentType ===
        COMPONENT_TYPES.CRYPTOPEDIA_SMALL_CARD
    ) || {};
  args.cryptopediaSmallCard.title = get(
    cryptopediaSmallCard?.fields,
    "title",
    ""
  );
  args.cryptopediaSmallCard.subTitle = get(
    cryptopediaSmallCard?.fields,
    "subtitle",
    ""
  );
  args.cryptopediaSmallCard.coinFullName = get(
    props?.initialOverview,
    "name",
    ""
  );
  const cryptopediaSmallCardCta = cryptopediaSmallCard?.fields?.cta || [];
  if (!isEmpty(cryptopediaSmallCardCta)) {
    cryptopediaSmallCardCta.forEach((data: any) => {
      const ctaCloneData = cloneDeep(ctaData);
      ctaCloneData.name = get(data?.fields, "title", "");
      ctaCloneData.link = get(data?.fields, "link", "");
      args.cryptopediaSmallCard.cta.push(ctaCloneData);
    });
  }
  args.cryptopediaSmallCard.isDisplay = cryptopediaSmallCardCta.length > 0;
  const cryptopediaSmallCardImages =
    cryptopediaSmallCard?.fields?.imageDesktop || [];
  if (!isEmpty(cryptopediaSmallCardImages)) {
    if (cryptopediaSmallCardImages?.length > 0) {
      args.cryptopediaSmallCard.image.url = get(
        cryptopediaSmallCardImages[0]?.fields?.file,
        "url",
        ""
      );
      args.cryptopediaSmallCard.image.width = get(
        cryptopediaSmallCardImages[0]?.fields?.file?.details?.image,
        "width",
        null
      );
      args.cryptopediaSmallCard.image.height = get(
        cryptopediaSmallCardImages[0]?.fields?.file?.details?.image,
        "height",
        null
      );
      args.cryptopediaSmallCard.image.altText = get(
        cryptopediaSmallCardImages[0]?.fields,
        "title",
        ""
      );
    }
  }

  const priceBlogs =
    find(
      pricePageListData,
      (el) =>
        el?.fields?.componentType?.fields?.componentType ===
        COMPONENT_TYPES.PRICE_BLOG
    ) || {};
  args.priceBlogs.title = get(priceBlogs?.fields, "title", "");
  args.priceBlogs.coinFullName = get(props?.initialOverview, "name", "");
  args.priceBlogs.coinSlug = get(props?.initialOverview, "slug", "");

  const priceArticle =
    find(
      pricePageListData,
      (el) =>
        el?.fields?.componentType?.fields?.componentType ===
        COMPONENT_TYPES.PRICE_ARTICLE
    ) || {};
  args.priceArticles.title = get(priceArticle?.fields, "title", "");
  args.priceArticles.coinFullName = get(props?.initialOverview, "name", "");
  args.priceArticles.coinSlug = get(props?.initialOverview, "slug", "");

  const tradeForm =
    find(
      pricePageListData,
      (el) =>
        el?.fields?.componentType?.fields?.componentType ===
        COMPONENT_TYPES.TRADE_FORM
    ) || {};

  args.tradeForm.title = get(tradeForm?.fields, "title", "");
  args.tradeForm.coinFullName = get(props?.initialOverview, "name", "");
  args.tradeForm.coinName = get(props?.initialOverview, "coin", "");
  args.tradeForm.isCustody = get(props?.initialOverview, "isCustody", false);
  args.tradeForm.isTrading = get(props?.initialOverview, "isTrading", false);
  const tradeFormCta = tradeForm?.fields?.cta || [];
  if (!isEmpty(tradeFormCta)) {
    tradeFormCta.forEach((data: any) => {
      const ctaCloneData = cloneDeep(ctaData);
      ctaCloneData.name = get(data?.fields, "title", "");
      ctaCloneData.link = get(data?.fields, "link", "");
      args.tradeForm.cta.push(ctaCloneData);
    });
  }

  return args;
};

export const formatPrice = Intl.NumberFormat("en-US", {
  currency: "USD",
  style: "currency",
  maximumFractionDigits: 10,
  minimumFractionDigits: 2
}).format;

export const createPriceFormatter = (precision: number = 2) => {
  return Intl.NumberFormat("en-US", {
    currency: "USD",
    style: "currency",
    maximumFractionDigits: Math.max(precision, 2),
    minimumFractionDigits: precision === 0 ? 0 : 2
  }).format;
};

export const createYAxisFormatter = (precision: number = 2) => {
  return Intl.NumberFormat("en-US", {
    currency: "USD",
    style: "currency",
    maximumFractionDigits: Math.max(precision, 2),
    minimumFractionDigits: 0,
    notation: "compact",
    compactDisplay: "short",
    roundingPriority: "lessPrecision"
  }).format;
};

export function timeToTz(originalTime) {
  // Create a Date object in the user's time zone
  const userTimeZoneDate = new Date(originalTime);

  // Get the UTC time as a timestamp in seconds
  const timestampInSeconds = userTimeZoneDate.getTime() / 1000;

  return timestampInSeconds;
}
export function formatTimestampToUTC(timestamp: number): string {
  // Safety check for invalid timestamps
  if (!timestamp || typeof timestamp !== "number" || !isFinite(timestamp)) {
    timestamp = Date.now();
  }

  // Check if the timestamp is in seconds (e.g., 1679021349) rather than milliseconds
  if (timestamp < 1e12) {
    // Multiply the timestamp by 1000 to convert it to milliseconds
    timestamp *= 1000;
  }

  // Create a Date object from the timestamp
  const date = new Date(timestamp);

  // Safety check for invalid date
  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }

  // Extract date components
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Month is zero-based
  const day = String(date.getUTCDate()).padStart(2, "0");
  const hours = String(date.getUTCHours()).padStart(2, "0");
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");

  // Construct the formatted date string
  const formattedDate = `${year}/${month}/${day} ${hours}:${minutes} (UTC)`;

  return formattedDate;
}

export const candleData = (data = testData) =>
  data
    .map((arr) => ({
      time: timeToTz(arr[0]) as UTCTimestamp,
      open: arr[1],
      high: arr[2],
      low: arr[3],
      close: arr[4]
    }))
    .sort((a, b) => a.time - b.time);

export const lineData = (data) => {
  return (
    data
      ?.map((_) => ({ time: (_.x / 1e3) as UTCTimestamp, value: _.y }))
      .sort((a, b) => a.time - b.time) ?? []
  );
};

export const dedupeChartData = (data) => {
  return data.filter(
    (point, i, arr) => i === 0 || point.time > arr[i - 1].time
  );
};

/**
 * Appends today's price to the range array if the latest data point is
 * not for today when the timeframe is either "1y" or "all".
 * This function works for both "1y" and "all" timeframes.
 * @param range - Array of { time: timestamp, value: price }
 * @param currentPrice - Latest price value
 */
export function appendTodayPriceFor1YTimeframe(
  range: { time: number; value: number }[],
  currentPrice: number
) {
  if (!range || range.length === 0) return range;

  const lastPoint = range[range.length - 1];

  // Get current UTC date components
  const now = new Date();
  const year = now.getUTCFullYear();
  const month = now.getUTCMonth();
  const day = now.getUTCDate();
  // Midnight UTC milliseconds
  const todayMidnightMs = Date.UTC(year, month, day, 0, 0, 0, 0);
  // Midnight UTC seconds
  const todayMidnightSec = Math.floor(todayMidnightMs / 1000);

  // If last point is before today, append today's price
  if (lastPoint.time < todayMidnightSec) {
    return [...range, { time: todayMidnightSec, value: currentPrice }];
  }
  return range;
}
